
import React, { PureComponent, Component } from "react";
import styles from "./Calendar.scss";
import { t, x } from "../../../helpers/localization";
import { translate, Interpolate } from "react-i18next";

import moment from "moment";

import { Progress } from "./Parts";

import { IStages, WarSettingsStages, IWarSettings } from "../../../Reducers/ReducerClanWars";

export type IProps = {
  currentWeek: number;
  weeksCount: number;
  stages: WarSettingsStages;
  currentStage: string;
  currentRound: number;
};

export type IState = {};

export type IDays = Array<string>;

export type IMonth = Array<string>;

class Calendar extends PureComponent<IProps, IState> {


  state = {
    progressWidth: 0
  };

  days: IDays = [t('понедельник'), t('вторник'), t('среда'), t('четверг'), t('пятница'), t('суббота'), t('воскресенье')];

  month: IMonth = [t('Январь'), t('Февраль'), t('Март'), t('Апрель'), t('Май'), t('Июнь'), t('Июль'), t('Август'), t('Сентябрь'), t('Октябрь'), t('Ноябрь'), t('Декабрь')];

  renderDaysTitles = (): Array<React.DOM> => {
    return this.days.map((item: string, index: number): any => {
      const needRightBorder = index < 6;
      const isWeekend = index > 4;

      return <div className={styles.cell} key={`dayTitle${index}`}>
                    <div className={`${styles.dayTitle} ${needRightBorder ? styles.rightBorder : ''} ${isWeekend ? styles.dayTitleWeekend : ''}`}>{`${item}`}</div>
                </div>;
    });
  };

  static getDayOffset = (weekIndex: number, dayIndex: number, currentWeek: number) => {
    let currentDayOffset = moment.utc().isoWeekday();

    if (weekIndex === currentWeek) {
      return -currentDayOffset + dayIndex;
    } else {
      if (weekIndex < currentWeek) {
        return -currentDayOffset + dayIndex - 7 * (currentWeek - weekIndex);
      } else {
        return -currentDayOffset + dayIndex + 7 * (weekIndex - currentWeek);
      }
    }
  };

  static getDateDayNumber = (offset: number) => {
    const m = moment.utc();
    if (offset === 0) {
      return m;
    } else {
      if (offset < 0) {
        return m.subtract(-offset, 'days');
      } else {
        return m.add(offset, 'days');
      }
    }
  };

  renderDays = (weekIndex: number) => {
    const days = [];
    for (let index = 0; index < 7; index++) {
      const dayIndex = index + 1;
      const needRightBorder = dayIndex < 7;
      const dayOffset = Calendar.getDayOffset(weekIndex, dayIndex, this.props.currentWeek);
      const date = Calendar.getDateDayNumber(dayOffset);
      const dateNum = date.format('D');
      const isActiveDay = weekIndex === this.props.currentWeek;

      days.push(<div className={styles.cell} key={`day${index}`}>
                    <div className={`${styles.day} ${needRightBorder ? styles.rightBorder : ''} ${isActiveDay ? styles.activeDay : ''}`}>
                        {this.renderStages(date)}
                        {`${dateNum}`}
                    </div>
                </div>);
    }

    return days;
  };

  getOverlayOffset = (date: any, isRight: boolean) => {
    const dayStart = moment.utc(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const msDiff = date.diff(dayStart);
    const msDay = 24 * 60 * 60 * 1000;
    const percentDiff = msDiff / msDay * 100;
    if (isRight) {
      return 100 - percentDiff;
    } else {
      return percentDiff;
    }
  };

  getInnerOverlay = (key: string, inCalendar?: boolean) => {
    switch (key) {

      case 'preparation':
        {
          return <div className={styles.preparationInnerOverlay} />;
        }
      case 'matchmaking':
        {
          if (this.props.currentStage === 'war' && inCalendar === true) {
            return <div className={styles.matchmakingInnerOverlayInWar} />;
          }
          return <div className={styles.matchmakingInnerOverlay} />;
        }
      case 'war':
        {
          return <div className={styles.warInnerOverlay} />;
        }
      // case 'rewarding': {
      //     return (
      //         <div className={styles.rewardingInnerOverlay} />
      //     )
      // }
      // case 'lull': {
      //     return (
      //         <div className={styles.lullInnerOverlay} />
      //     )
      // }

      default:
        {
          return null;
        }

    }
  };

  renderStages = (date: any) => {
    const stages = [];

    for (const key in this.props.stages) {
      if (this.props.stages.hasOwnProperty(key)) {
        const stageName = key;
        const stage = this.props.stages[key];

        if (stage.startDate && stage.endDate) {
          const stageStartDate = moment.utc(stage.startDate);
          const stageEndDate = moment.utc(stage.endDate);
          const stageStartDateDayIndex = parseInt(stageStartDate.format('DDDD'));
          const stageEndDateDayIndex = parseInt(stageEndDate.format('DDDD'));
          const dateDayIndex = parseInt(date.format('DDDD'));

          // console.log(stageName, stageStartDate)

          if (dateDayIndex === stageStartDateDayIndex && dateDayIndex === stageEndDateDayIndex) {
            stages.push(<div key={`PrepOverlay_${dateDayIndex}_${stageName}`} className={styles.stageOverlay} style={{
              left: `${this.getOverlayOffset(stageStartDate, false)}%`,
              right: `${this.getOverlayOffset(stageEndDate, true)}%`,
              zIndex: -2
            }}>{this.getInnerOverlay(stageName, true)}</div>);
          } else if (dateDayIndex === stageStartDateDayIndex) {
            stages.push(<div key={`PrepOverlay_${dateDayIndex}_${stageName}`} className={styles.stageOverlay} style={{
              left: `${this.getOverlayOffset(stageStartDate, false)}%`
            }}>{this.getInnerOverlay(stageName, true)}</div>);
          } else if (dateDayIndex === stageEndDateDayIndex) {
            stages.push(<div key={`PrepOverlay_${dateDayIndex}_${stageName}`} className={styles.stageOverlay} style={{
              right: `${this.getOverlayOffset(stageEndDate, true)}%`
            }}>{this.getInnerOverlay(stageName, true)}</div>);
          } else if (dateDayIndex > stageStartDateDayIndex && dateDayIndex < stageEndDateDayIndex) {
            stages.push(<div key={`PrepOverlay_${dateDayIndex}_${stageName}`} className={styles.stageOverlay}>{this.getInnerOverlay(stageName, true)}</div>);
          }
        }

      }
    }

    return stages;
  };

  renderWeeks = () => {
    const weeks = [];

    for (let index = 0; index < this.props.weeksCount; index++) {
      const weekIndex = index + 1;
      const isCurrentWeek = this.props.currentWeek === weekIndex;

      weeks.push(<div key={`Week_${weekIndex}`} className={`${styles.week} ${isCurrentWeek ? styles.currentWeek : ''}`}>
                    {this.renderDays(weekIndex)}
                    {isCurrentWeek ? <Progress /> : null}
                </div>);
    }

    return weeks;
  };

  getStageName = (key: string) => {
    switch (key) {
      case 'preparation':
        {
          return t('Подготовка');
        }
      case 'matchmaking':
        {
          return t('Подбор соперников');
        }
      case 'war':
        {
          return t('Битва');
        }

      default:
        {
          return '';
        }

    }
  };

  renderLegend() {
    const stages = [];

    for (const key in this.props.stages) {
      if (this.props.stages.hasOwnProperty(key)) {
        const stageName = key;
        const stage = this.props.stages[key];

        if (stageName === 'preparation' || stageName === 'matchmaking' || stageName === 'war') {
          stages.push(<div className={styles.legendStage} key={`LegendStage_${stageName}`}>
                            <div className={`${styles.stageBox} ${stageName === 'matchmaking' ? styles.topBottomBorder : ''}`}>
                                {this.getInnerOverlay(stageName)}
                            </div>
                            <span className={styles.stageName}>
                                {this.getStageName(stageName)}
                            </span>
                        </div>);
        }
      }
    }

    return stages;
  }

  render() {

    return <div className={styles.wrapper}>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Текущий раунд %(currentRound)s')} currentRound={this.props.currentRound} parent={'span'} className={styles.seasonTitle} />
                <div className={styles.innerWrapper}>
                    <div className={styles.dayTitleRow}>
                        {this.renderDaysTitles()}
                    </div>
                    {this.renderWeeks()}
                </div>

                <div className={styles.legend}>
                    {this.renderLegend()}
                </div>
            </div>;
  }
}

export default Calendar;